module.exports = __webpack_public_path__ + "static/device_phone_apple_dark-9d415b0dd4a4e04feb0f95fe36c66bd2.png";